import React from 'react';

const Footer = () => (
  <div className="footer">
    <p className="footer__text">
      Copyright &#169;
      {' '}
      <a className="footer__link" href="https://github.com/ArthurGC/math-magicians.project">ArthurGC</a>
      {' '}
      | REACT.
    </p>
  </div>
);

export default Footer;
